import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

(document.getElementById("output") as HTMLTextAreaElement).value = "";

var selectionListenerId = -1;
var selectionListenerId_2 = -1;

function ex_reg_id() {
  LwAPI?.registerOnSelection(function (selectedItem) {
    if (selectedItem.item != null) {
      var d = new Date();
      (document.getElementById("output") as HTMLTextAreaElement).value =
        "Current time: " +
        d.toLocaleTimeString() +
        "\n\n" +
        JSON.stringify(selectedItem, null, 2);
    }
  })
    .then(function (listenerId) {
      selectionListenerId = listenerId;
    })
    .catch(function (err) {
      (document.getElementById("output") as HTMLTextAreaElement).value =
        JSON.stringify(err, null, " ");
    });
}

function ex_reg_props() {
  LwAPI?.registerOnSelection(function (selectedItem) {
    if (selectedItem.item != null) {
      var list = "";
      var id = selectedItem.item.modelId + ":" + selectedItem.item.modelItemId;
      LwAPI?.getProperties(id).then(function (props) {
        for (var i = 0; i < props.data.length; i++) {
          list += props.data[i]["name"] + " = " + props.data[i]["value"] + "\n";
        }
        var d = new Date();
        (document.getElementById("output") as HTMLTextAreaElement).value =
          "Current time: " + d.toLocaleTimeString() + "\n\n" + list;
      });
    }
  }).then(function (listenerId) {
    selectionListenerId_2 = listenerId;
  });
}

function ex_unreg_id() {
  LwAPI?.unregisterOnSelection(selectionListenerId);
}

function ex_unreg_props() {
  LwAPI?.unregisterOnSelection(selectionListenerId_2);
}

// Bind functions to buttons
document.getElementById("itemid")?.addEventListener("click", async () => {
  await apiReady;
  ex_reg_id();
});
document.getElementById("props")?.addEventListener("click", async () => {
  await apiReady;
  ex_reg_props();
});
document.getElementById("unregprops")?.addEventListener("click", async () => {
  await apiReady;
  ex_unreg_props();
});
document.getElementById("unregid")?.addEventListener("click", async () => {
  await apiReady;
  ex_unreg_id();
});
